module.exports = __webpack_public_path__ + "img/home-world-best-banner-03-on.9fedbb09.jpg";